import { render } from "./learnDBC.vue?vue&type=template&id=5d1b5825&scoped=true"
import script from "./learnDBC.vue?vue&type=script&lang=js"
export * from "./learnDBC.vue?vue&type=script&lang=js"

import "./learnDBC.vue?vue&type=style&index=0&id=5d1b5825&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1b5825"]])

export default __exports__